export default __webpack_public_path__ + "static/media/work-portfolio-img2.c258bb61.png";